import { apiClient } from '@/shared/api/http-client';

import {
    getMerchantOnboardingStatus,
    merchantCreateDashboardLink,
    merchantCreateOnboardingLink,
} from '../model/merchant.schemas';
import type {
    MerchantDashboardLink,
    MerchantOnboardingLink,
    MerchantOnboardingStatus,
} from '../model/merchant.types';

export const merchantApi = {
    getOnboardingStatus: async (signal?: AbortSignal): Promise<MerchantOnboardingStatus> => {
        const data = await apiClient.get('/merchants/onboarding/status', signal);
        return getMerchantOnboardingStatus.output.parse(data).status;
    },
    createOnboardingLink: async (signal?: AbortSignal): Promise<MerchantOnboardingLink> => {
        const data = await apiClient.post('/merchants/onboarding/link', undefined, signal);
        return merchantCreateOnboardingLink.output.parse(data);
    },
    createDashboardLink: async (signal?: AbortSignal): Promise<MerchantDashboardLink> => {
        const data = await apiClient.post('/merchants/dashboard/link', undefined, signal);
        return merchantCreateDashboardLink.output.parse(data);
    },
};
